export default {
    "nm": "Nhập mới",
    "return": "Return",
}
